/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route__itineraries__many = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} mögliche Routen`
};

const en_route__itineraries__many = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} possible itineraries`
};

const es_route__itineraries__many = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} itinerarios posibles`
};

const fr_route__itineraries__many = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} itinéraires possibles`
};

const it_route__itineraries__many = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} itinerari possibili`
};

const nl_route__itineraries__many = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} mogelijke routes`
};

const pt_route__itineraries__many = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.count} itinerário possíveis`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ count: NonNullable<unknown> }} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route__itineraries__many = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route__itineraries__many(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route__itineraries__many", locale)
	if (locale === "de") return de_route__itineraries__many(inputs)
	if (locale === "en") return en_route__itineraries__many(inputs)
	if (locale === "es") return es_route__itineraries__many(inputs)
	if (locale === "fr") return fr_route__itineraries__many(inputs)
	if (locale === "it") return it_route__itineraries__many(inputs)
	if (locale === "nl") return nl_route__itineraries__many(inputs)
	return pt_route__itineraries__many(inputs)
};